import React from 'react';
import TransactionTabsHeader from '@pano-project/components/TransactionTabsHeader/TransactionTabsHeader';
import { useBootHeaderSettings } from './useBootHeaderSettings';

const passthroughLang = (key: string) => key;

const BootHeader = () => {
  const { shouldRender, layout } = useBootHeaderSettings();

  if (!shouldRender) return null;

  if (layout === 'amount-first') {
    return (
      <div className="amount-first-page__content-wrapper">
        <div className="amount-first-page">
          <div className="amount-first-page__main-fold">
            <TransactionTabsHeader transactionType="" lang={passthroughLang} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <header className="main-header _show-hide-and-back-buttons">
      <TransactionTabsHeader
        transactionType=""
        lang={passthroughLang}
        isAmountFirstLayout={false}
        className="main-header__tabs"
      />
    </header>
  );
};

export default BootHeader;
